import { ILogService } from "./ILogService";

export class ApiLogService implements ILogService {
    logError = (error: Error, errorInfo: any): void => {

    }
}